module.exports = __webpack_public_path__ + "fonts/iconfont.8c94bad6.ttf";